import { gql } from '@apollo/client';

export const GET_PDA_HOME_MENU_BASIC_CONFIG = gql`
  query GetPdaHomeMenuBasicConfig {
    getPdaHomeMenuBasicConfig {
      id
      siteType
      i18nKey
      isChecked
      items {
        id
        siteType
        configPath
        configIcon
        i18nKey
        backgroundColor
        isChecked
      }
    }
  }
`;

export const GET_PDA_HOME_MENUS_BY_WAREHOUSE_ID = gql`
  query GetPdaHomeMenusByWarehouseId($warehouseId: Long!, $accountRole: String!) {
    getPdaHomeMenusByWarehouseId(warehouseId: $warehouseId, accountRole: $accountRole) {
      warehouseId
      accountRole
      menuConfigIds
    }
  }
`;

export const CREATE_PDA_HOME_MENUS = gql`
  mutation CreatePdaHomeMenus($input: PdaHomeMenuInfoTypeInput!) {
    createPdaHomeMenus(input: $input)
  }
`;

export const UPDATE_PDA_MENU_CONFIG_ICON = gql`
  mutation UpdatePdaMenuConfigIcon($id: Long!, $configIcon: String!) {
    updatePdaMenuConfigIcon(id: $id, configIcon: $configIcon)
  }
`;

export const UPLOAD_PDA_MENU_ICON = gql`
  mutation UploadPdaMenuIcon($input: UploadPdaMenuIconInput!) {
    uploadPdaMenuIcon(input: $input) {
      objectKey
      publicUrl
    }
  }
`;

export const GET_WAREHOUSES = gql`
  query GetWarehouses {
    warehouseList: getWarehouseList {
      id
      name
      sortingCode
      siteType
    }
  }
`;

export const GET_PDA_HOME_MENU_PAGE_LIST = gql`
  query GetPdaHomeMenuPageList(
    $filters: PdaHomeMenuPageFiltersInput
    $pageRequest: PdaHomeMenuPageRequestInput
  ) {
    getPdaHomeMenuPageList(filters: $filters, pageRequest: $pageRequest) {
      content {
        groupId
        warehouseId
        warehouseName
        accountRole
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;
